import React, { useEffect, useState } from "react";
import {useNavigate } from "react-router-dom";


const MyListing = () => {
  const steps = ['Basic Details', 'Property Details', 'Price Details'];
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  // State to store form data for all steps
  const [formData, setFormData] = useState({
    basicDetails: { type: '', service: '', address: '' },
  });

  const [errors, setErrors] = useState({});



  useEffect(() => {

    if(formData.basicDetails?.type !== '' && formData.basicDetails?.service !== '' )
    {
      const url = `/my-listings/new/basic?category=${formData.basicDetails?.type}&service=${formData.basicDetails?.service}`;
      navigate(url,{ replace: true });
    }
   
  },[formData.basicDetails?.type , formData.basicDetails?.service]);


  const handleInputChange = (step, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: '', // Clear error for the field being modified
    }));
  };

  const validateStep = () => {
    const newErrors = {};
    if (activeStep === 0) {
      if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
      if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
      if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
    }
   
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };




  const renderComponentByCategoryAndService = () => {
    if (formData.basicDetails.type === "residential" && formData.basicDetails.service === "rent") {
      return <ResidentialRent />;
    } else if (formData.basicDetails.type === "residential" && formData.basicDetails.service === "sell") {
      return <ResidentialSell />;
    } 
    else if (formData.basicDetails.type === "commercial" && formData.basicDetails.service === "rent") {
      return <CommercialRent />;
    } 
    else if (formData.basicDetails.type === "commercial" && formData.basicDetails.service === "sell") {
      return <CommercialSell />;
    } 
    else {
      return <DefaultListingComponent />;
      
    }
  };
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                >
                  Commercial
                </button>
              </div>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Looking to</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                >
                  Rent
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                >
                  Sell
                </button>
              </div>
              {errors.service && <small className="text-danger">{errors.service}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.basicDetails.address}
                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
              />
              {errors.address && <small className="text-danger">{errors.address}</small>}
            </div>
          </div>
        );
      }
  };

  return (
    <>
    {activeStep === 0 ? renderComponentByCategoryAndService() : null}
    </>
  );
};



const DefaultListingComponent = () => {
  const steps = ['Basic Details', 'Property Details', 'Price Details'];
  const [activeStep, setActiveStep] = useState(0);

  // State to store form data for all steps
  const [formData, setFormData] = useState({
    basicDetails: { type: '', service: '', address: '' },
    
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (step, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: '', // Clear error for the field being modified
    }));
  };

  const validateStep = () => {
    const newErrors = {};
    if (activeStep === 0) {
      if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
      if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
      if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                >
                  Commercial
                </button>
              </div>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Looking to</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                >
                  Rent
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                >
                  Sell
                </button>
              </div>
              {errors.service && <small className="text-danger">{errors.service}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.basicDetails.address}
                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
              />
              {errors.address && <small className="text-danger">{errors.address}</small>}
            </div>
          </div>
        );
      
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-4">
          <div className="list-group">
            {steps.map((step, index) => (
              <button
                key={index}
                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                onClick={() => setActiveStep(index)}
              >
                {step}
              </button>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-header">{steps[activeStep]}</div>
            <div className="card-body">{renderStepContent(activeStep)}</div>
            <div className="card-footer text-end">
              {activeStep > 0 && (
                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Previous
                </button>
              )}
              {activeStep < steps.length - 1 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>
                  Next
                </button>
              ) : (
                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



const ResidentialSell = () => {
  const steps = ['Basic Details', 'Property Details', 'Photos', 'Review & Submit'];
  const [activeStep, setActiveStep] = useState(0);

  // State to store form data for all steps
  const [formData, setFormData] = useState({
    basicDetails: { type: '', service: '', address: '' },
    propertyDetails: { property_type: '', building: '', locality: '', furnish_type: '',
       bhk: '',builtup:'',plot_area:'',plot_area_unit:'',plot_length:'',plot_width:'' },
    photos: { files: null },
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (step, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: '', // Clear error for the field being modified
    }));
  };

  const validateStep = () => {
    const newErrors = {};
    if (activeStep === 0) {
      if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
      if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
      if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
    }
    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

    }
    if (activeStep === 2) {
      if (!formData.photos.files) newErrors.files = "Please upload at least one photo.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                >
                  Commercial
                </button>
              </div>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Looking to</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                >
                  Rent
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                >
                  Sell
                </button>
              </div>
              {errors.service && <small className="text-danger">{errors.service}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.basicDetails.address}
                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
              />
              {errors.address && <small className="text-danger">{errors.address}</small>}
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'apartment' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'apartment')}
                >
                  Apartment
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_floor' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_floor')}
                >
                  Independent Floor
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_house' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_house')}
                >
                  Independent House
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'villa' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'villa')}
                >
                  Villa
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'plot' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'plot')}
                >
                  Plot
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'agricultural_land' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'agricultural_land')}
                >
                  Agricultural Land
                </button>
              </div>
              {errors.property_type && <small className="text-danger">{errors.property_type}</small>}
            </div>



            <div className="mb-3">
              <label className="form-label">Building/Project/Society</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.building}
                onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
              />
              {errors.building && <small className="text-danger">{errors.building}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Locality</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.locality}
                onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
              />
              {errors.locality && <small className="text-danger">{errors.locality}</small>}
            </div>

            {formData.propertyDetails.property_type !== 'plot' && (
            <div className="mb-3">
              <label className="form-label">Furnish Type</label>
              <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.furnish_type === 'fully_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'fully_furnished')}
                >
                  Fully Furnished
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.furnish_type === 'semi_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'semi_furnished')}
                >
                  Semi Furnished
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.furnish_type === 'unfurnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'unfurnished')}
                >
                  Unfurnished
                </button>

              </div>
            </div>

)}
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="shareListing"
                  checked={formData.propertyDetails.share_listing || false} // Ensure it's boolean
                  onChange={(e) => handleInputChange('propertyDetails', 'share_listing', e.target.checked)} // Use `checked`
                />
                <label className="form-check-label" htmlFor="shareListing">
                  Share the listing with the agent
                </label>
              </div>
              {errors.share_listing && <small className="text-danger">{errors.share_listing}</small>}
            </div>

            {formData.propertyDetails.property_type === 'independent_floor' && (
              <>
                <div className="mb-3">
                  <label className="form-label">BHK</label>
                  <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>

                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 rk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 rk')}
                    >
                      1 RK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 bhk')}
                    >
                      1 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1.5 bhk')}
                    >
                      1.5 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '2 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '2 bhk')}
                    >
                      2 BHK
                    </button>


                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Built Up</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.builtup}
                    onChange={(e) => handleInputChange('propertyDetails', 'builtup', e.target.value)}
                  />
                  {errors.builtup && <small className="text-danger">{errors.builtup}</small>}
                </div>

              </>
            )}

            {formData.propertyDetails.property_type === 'plot' && (
              <>
               <div className="mb-3">
                  <label className="form-label">Plot Area</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_area}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_area', e.target.value)}
                  />
                  {errors.plot_area && <small className="text-danger">{errors.plot_area}</small>}
                </div>
               <div className="mb-3">
                  <label className="form-label">Select Area Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_area_unit}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_area_unit', e.target.value)}
                  />
                  {errors.plot_area_unit && <small className="text-danger">{errors.plot_area_unit}</small>}
                </div>
               <div className="mb-3">
                  <label className="form-label">Length</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_length}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_length', e.target.value)}
                  />
                  {errors.plot_length && <small className="text-danger">{errors.plot_length}</small>}
                </div>
               <div className="mb-3">
                  <label className="form-label">Width</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_width}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_width', e.target.value)}
                  />
                  {errors.plot_width && <small className="text-danger">{errors.plot_width}</small>}
                </div>
              </>
            )}

          </div>
        );
      case 2:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Upload Photos</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={(e) => handleInputChange('photos', 'files', e.target.files)}
              />
              {errors.files && <small className="text-danger">{errors.files}</small>}
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Review</label>
              <div>
                <p>Review all the entered details:</p>
                <pre>{JSON.stringify(formData, null, 2)}</pre>
                <button type="submit" className="btn btn-success">
                  Submit
                </button>
              </div>
            </div>
          </div>
        );
      default:
        return <p>Select a step to continue.</p>;
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-4">
          <div className="list-group">
            {steps.map((step, index) => (
              <button
                key={index}
                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                onClick={() => setActiveStep(index)}
              >
                {step}
              </button>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-header">{steps[activeStep]}</div>
            <div className="card-body">{renderStepContent(activeStep)}</div>
            <div className="card-footer text-end">
              {activeStep > 0 && (
                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Previous
                </button>
              )}
              {activeStep < steps.length - 1 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>
                  Next
                </button>
              ) : (
                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// Different components for each category and service
const ResidentialRent = () => <div>Residential Rent Component</div>;
const CommercialRent = () => <div>Commercial Rent Component</div>;
const CommercialSell = () => <div>Commercial Sell Component</div>;

export default MyListing;
